import { render, staticRenderFns } from "./column.vue?vue&type=template&id=e1d1fc50&scoped=true&"
import script from "./column.vue?vue&type=script&lang=js&"
export * from "./column.vue?vue&type=script&lang=js&"
import style0 from "./column.vue?vue&type=style&index=0&id=e1d1fc50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d1fc50",
  null
  
)

export default component.exports